
import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    // 路由懒加载
    component: () => import('@/views/login')
  },
  {
    path: '/',
    // name: 'layout', // 如果父路由有默认子路git由，那它的 name 没有意义
    // 路由懒加载
    redirect: '/home',
    component: () => import('@/views/layout'),
    children: [
      {
        path: '/home', // 默认子路由
        name: 'home',
        component: () => import('@/views/home')
        // component: resolve => require(['@/views/home'], resolve)
        // 这种写法是异步模块获取，打包的时候每次访问这个路由的时候会单调单个文件，按需加载。还有种写法就是用import，这种是把component打包到一个文件里面，初次就读取全部
      },
      {
        // 消息跳转中转站
        path: '/home/transferStation',
        name: 'transferStation',
        component: () => import('@/views/home/transferStation')
      },
      {
        // 列表
        path: '/scrm',
        name: 'scrmIndex',
        component: () => import('@/views/scrm/index')
      },
      /** --------------------------------------SCRM客户关系管理------------------------------ **/
      {
        // 添加客户
        path: 'scrm/myCust/add', // PC端组件路径
        name: 'custAdd',
        component: () => import('@/views/scrm/custManage/add')
      },
      {
        // 添加客户2
        path: 'scrm/myCust/addInfos',
        name: 'custAddInfo',
        component: () => import('@/views/scrm/custManage/addInfos')
      },
      {
        // 修改客户
        path: 'scrm/myCust/modifyInfos',
        name: 'custModifyInfo',
        component: () => import('@/views/scrm/custManage/modifyInfos')
      },
      {
        // 查询客户
        path: 'scrm/myCust/list',
        name: 'custList',
        component: () => import('@/views/scrm/custManage/list')
        // meta: { keepAlive: true }
      },
      {
        // 客户共享
        path: 'scrm/myCust/share',
        name: 'share',
        component: () => import('@/views/scrm/custManage/share')
      },
      {
        // 客户详情
        path: '/scrm/custManage/detail/:id',
        name: 'custDetail',
        component: () => import('@/views/scrm/custManage/detail')
      },
      {
        // 离职继承日志
        path: 'scrm/myCust/inheritLog',
        name: 'inheritLog',
        component: () => import('@/views/scrm/custManage/inheritLog')
      },
      // 添加我的商机
      {
        path: 'scrm/custBo/add',
        name: 'boAddInfo',
        component: () => import('@/views/scrm/custBo/add')
      },
      {
        // 我的商机
        path: 'scrm/businessOpportunity/index',
        name: 'custBo',
        component: () => import('@/views/scrm/custBo/list')
        // meta: { keepAlive: true }
      },
      {
        // 我的商机详情
        path: '/scrm/custBo/detail/:id',
        name: 'boDetail',
        component: () => import('@/views/scrm/custBo/detail')
      },
      {
        // 客户公海列表
        path: 'scrm/highSeas/list',
        name: 'highseas',
        component: () => import('@/views/scrm/custHighseas/list')
      },
      {
        // 客户公海审核
        path: '/scrm/highSeas/audit',
        name: 'highseasAudit',
        component: () => import('@/views/scrm/custHighseas/audit')
      },
      /** --------------------------------------SCRM客户关系管理----------end-------------------- **/

      /** --------------------------------------合同管理------------------------------ **/
      {
        // 合同管理系统
        path: '/cont',
        name: 'contIndex',
        component: () => import('@/views/cont/index')
      },
      {
        // 申领合同
        path: 'cont/apply/list',
        name: 'apply',
        component: () => import('@/views/cont/apply/list'),
        meta: { keepAlive: true }
      },
      {
        // 申领合同详情
        path: 'cont/apply/detail',
        name: 'applyDetail',
        component: () => import('@/views/cont/apply/detail')
      },
      {
        // 申领合同记录
        path: 'cont/apply/sale_list',
        name: 'applyDecord',
        component: () => import('@/views/cont/apply/applyDecord')
      },
      {
        // 申领合同记录
        path: '/cont/apply/decordDetail',
        name: 'applyDecord',
        component: () => import('@/views/cont/apply/decordDetail')
      },
      {
        // 新增合同
        path: 'cont/contract/list',
        name: 'contract',
        component: () => import('@/views/cont/contract/list')
      },
      {
        // 合同起草
        path: 'cont/contract/bozza_list',
        name: 'contract',
        component: () => import('@/views/cont/contract/list'),
        meta: { keepAlive: true }
      },
      {
        // 新增合同
        path: 'cont/contract/add',
        name: 'contractAdd',
        component: () => import('@/views/cont/contract/add')
      },
      {
        // 业务员限时修改合同
        path: 'cont/approve/timeLimited',
        name: 'contractModify',
        component: () => import('@/views/cont/approve/timeLimited')
      },
      {
        // 合同审批
        path: 'cont/approve/list',
        name: 'agency_contract',
        component: () => import('@/views/cont/approve/list')
        // meta: { keepAlive: true }
      },
      {
        // 合同补充协议审批
        path: 'cont/approve/agreementList',
        name: 'agreementList',
        component: () => import('@/views/cont/approve/agreementList'),
        meta: { keepAlive: true }
      },
      {
        // 合同审批-详情
        path: 'cont/approve/detail',
        name: 'agency_contract',
        component: () => import('@/views/cont/approve/detail')
      },
      {
        // 合同查询-归档
        path: 'cont/archiving/new_list',
        name: 'archiving_list',
        component: () => import('@/views/cont/archiving/list'),
        meta: { keepAlive: true }
      },
      // 企业微信跳转审批页面
      {
        path: 'cont/contract/approval/',
        name: 'contractApprove',
        component: () => import('@/views/cont/contract/approval')
      },
      {
        // 付款单位列表
        path: 'cont/payment/payerList',
        name: 'payerList',
        component: () => import('@/views/cont/payment/payerList')
      },
      {
        // 执行客户列表
        path: 'cont/payment/executiveList',
        name: 'executiveList',
        component: () => import('@/views/cont/payment/executiveList')
      },
      {
        // 补充协议列表
        path: 'cont/payment/agreementList',
        name: 'agreementList',
        component: () => import('@/views/cont/payment/agreementList')
      },
      {
        // 补充协议
        path: 'cont/payment/supplyAgreeList',
        name: 'supplyAgreeList',
        component: () => import('@/views/cont/payment/supplyAgreeList')
      },
      {
        // 收款列表
        path: 'cont/payment/paymentList',
        name: 'paymentList',
        component: () => import('@/views/cont/payment/paymentList')
      },
      {
        // 渠道收款列表
        path: 'channel/management/paymentList',
        name: 'chPaymentList',
        component: () => import('@/views/channel/management/paymentList')
      },
      {
        // 新增收款
        path: 'cont/payment/addPayment',
        name: 'addPayment',
        component: () => import('@/views/cont/payment/addPayment')
      },
      {
        // 收款详情及认领
        path: 'cont/payment/paymentDetail',
        name: 'paymentDetail',
        component: () => import('@/views/cont/payment/paymentDetail')
      },
      {
        // 收款认领确认页面
        path: 'cont/payment/paymentConfirm',
        name: 'paymentConfirm',
        component: () => import('@/views/cont/payment/paymentConfirm')
      },
      {
        // 充值列表页面
        // 充值申请 退款 调拨
        path: 'channel/recharge/rechargeApplication',
        name: 'rechargeList',
        component: () => import('@/views/channel/recharge/rechargeApplication')
      },
      {
        // 凭证
        // 充值申请 退款 调拨
        path: 'channel/recharge/credentials',
        name: 'rechargeList',
        component: () => import('@/views/channel/recharge/credentials')
      },
      {
        // 充值列表页面
        path: 'cont/payment/rechargeList',
        name: 'rechargeList',
        component: () => import('@/views/cont/payment/rechargeList')
      },
      {
        // 垫款充值列表页面
        path: 'channel/recharge/advanceRecharge',
        name: 'advancesRecharge',
        component: () => import('@/views/channel/recharge/advancesRecharge')
      },
      {
        // 渠道充值列表页面
        path: 'channel/recharge/rechargeList',
        name: 'channelRechargeList',
        component: () => import('@/views/channel/recharge/rechargeList')
      },
      {
        // 充值明细及相关操作页面
        path: 'cont/payment/rechargeDetail',
        name: 'rechargeDetail',
        component: () => import('@/views/cont/payment/rechargeDetail')
      },
      {
        // 添加收款
        path: 'cont/payment/addList',
        name: 'addList',
        component: () => import('@/views/cont/payment/addList')
      },
      {
        // 收款确认
        path: 'cont/payment/confirmList',
        name: 'confirmList',
        component: () => import('@/views/cont/payment/confirmList')
      },
      {
        // 收款确认详情
        path: 'cont/payment/detail',
        name: 'paymentDetail',
        component: () => import('@/views/cont/payment/detail')
      },
      {
        // 二维码收款订单
        path: 'cont/payment/qrCodeList',
        name: 'qrCodeList',
        component: () => import('@/views/cont/payment/qrCodeList')
      },
      {
        // 二维码收款订单详情
        path: 'cont/payment/qrCodeDetail',
        name: 'qrCodeDetail',
        component: () => import('@/views/cont/payment/qrCodeDetail')
      },
      {
        // 垫款管理
        path: 'cont/advances/addList',
        name: 'adAddList',
        component: () => import('@/views/cont/advances/addList')
      },
      {
        // 垫款列表（审批）
        path: 'cont/advances/approvalList',
        name: 'adApprovalList',
        component: () => import('@/views/cont/advances/approvalList')
      },
      {
        // 垫款列表（查询）
        path: 'cont/advances/queryList',
        name: 'adQueryList',
        component: () => import('@/views/cont/advances/queryList')
      },
      {
        // 垫款列表详情
        path: 'cont/advances/detail',
        name: 'adDetail',
        component: () => import('@/views/cont/advances/detail')
      },
      // {
      //   //合同审批——待办
      //   path: "cont/approve/agencyList",
      //   name: "agency_contract",
      //   component: () => import("@/views/cont/verify/agencyList")
      // },
      // {
      //   //合同审批——已办
      //   path: "cont/approve/doneList",
      //   name: "done_contract",
      //   component: () => import("@/views/cont/verify/doneList")
      // },
      // 合同归档——查询

      // {
      //   //合同审批——已办
      //   path: "cont/archiving/list",
      //   name: "archiving_contract",
      //   component: () => import("@/views/cont/archiving/index")
      // },
      {
        // 客户合同列表
        path: '/cont',
        name: 'contIndex',
        component: () => import('@/views/cont/index')
      },
      {
        // 未上传合同列表
        path: 'cont/putcontract/index',
        name: 'putcontract',
        component: () => import('@/views/cont/putcontract/index')
      },
      {
        // 未上传合同的订单详情
        path: 'cont/putcontract/detail',
        name: 'putcontractDetail',
        component: () => import('@/views/cont/putcontract/detail')
      },
      {
        // 未审核合同列表
        path: '/cont/nocontract/index',
        name: 'nocontract',
        component: () => import('@/views/cont/nocontract/index')
      },
      {
        // 已审核合同列表
        path: 'cont/contract/index',
        name: 'contract',
        component: () => import('@/views/cont/contract/index')
      },
      {
        // 已驳回合同列表
        path: '/cont/failcontract/index',
        name: 'failcontract',
        component: () => import('@/views/cont/failcontract/index')
      },
      {
        // 2019合同列表
        path: 'cont/sale2019/index',
        name: 'sale2019',
        component: () => import('@/views/cont/sale2019/index')
      },
      {
        // 2020合同列表
        path: 'cont/sale2020/index',
        name: 'sale2020',
        component: () => import('@/views/cont/sale2020/index')
      },
      {
        // 2021合同列表
        path: 'cont/sale2021/index',
        name: 'sale2021',
        component: () => import('@/views/cont/sale2021/index')
      },
      {
        // 2022合同列表
        path: 'cont/sale2022/index',
        name: 'sale2022',
        component: () => import('@/views/cont/sale2022/index')
      },
      {
        // 采购合同列表
        path: 'cont/othercontract/index',
        name: 'othercontract',
        component: () => import('@/views/cont/othercontract/index')
      },
      {
        // 采购合同列表
        path: 'cont/othercontract/index',
        name: 'othercontract',
        component: () => import('@/views/cont/othercontract/index')
      },
      {
        // 业务合同列表
        path: 'cont/nonbusiness/index',
        name: 'nonbusiness',
        component: () => import('@/views/cont/nonbusiness/index')
      },

      {
        // 合同详情
        path: '/contractdetail/',
        name: 'contractdetail',
        component: () => import('@/views/cont/contractdetail')
      },
      // V1.0 合同详情可以添加多个附件列表
      {
        path: '/ContDetail/',
        name: 'ContDetail',
        component: () => import('@/views/cont/ContDetail')
      },
      {
        // 2020、2019合同详情
        path: '/salecontractdetail/',
        name: 'salecontractdetail',
        component: () => import('@/views/cont/salecontractdetail')
      },
      {
        // 财务发票列表
        path: '/fina',
        name: 'finaIndex',
        component: () => import('@/views/fina/index')
      },
      {
        // 财务已发票列表
        path: '/fina/invoice/index',
        name: 'invoice',
        component: () => import('@/views/fina/invoice')
      },
      {
        // 财务未发票列表
        path: '/fina/noinvoice/index',
        name: 'noinvoice',
        component: () => import('@/views/fina/noinvoice')
      },
      {
        // 财务发票详情
        path: '/invoicedetail/:id',
        name: 'invoicedetail',
        component: () => import('@/views/fina/invoice/detail')
      },
      {
        // 财务收款列表
        path: '/fina/receivable/index',
        name: 'receivable',
        component: () => import('@/views/fina/receivable')
      },
      {
        // 财务收款详情
        path: '/receivableDetail/:id',
        name: 'receivableDetail',
        component: () => import('@/views/fina/receivable/detail')
      },
      {
        // 财务统计日记账详情
        // path: "/dayBookDetail/:id",
        path: '/fina/dayBookDetail/index/',
        name: 'dayBookDetail',
        component: () => import('@/views/fina/dayBookDetail/index')
      },
      {
        // 退款管理
        path: '/fina/refundManagement/refundApproval/',
        name: 'refundApproval',
        component: () => import('@/views/fina/refundManagement/refundApproval')
      },
      {
        // 退款管理详情
        path: '/fina/refundManagement/approvalDetail/',
        name: 'approvalDetail',
        component: () => import('@/views/fina/refundManagement/approvalDetail')
      },
      // {
      //   // 加班餐补明细
      //   path: '/admi/mealTonic/list',
      //   name: 'mealTonic',
      //   component: () => import('@/views/admi/mealTonic/detailedList')
      // },
      // {
      //   // 加班餐补明细详情
      //   path: '/admi/mealTonic/dDetail',
      //   name: 'mealTonicDdetail',
      //   component: () => import('@/views/admi/mealTonic/dDetail')
      // },
      {
        // 加班餐补主表
        path: '/admi/mealTonic/review',
        name: 'mealTonicReview',
        component: () => import('@/views/admi/mealTonic/review')
      },
      // {
      //   // 加班餐补主表详情
      //   path: '/admi/mealTonic/sDetail',
      //   name: 'mealTonicSdetail',
      //   component: () => import('@/views/admi/mealTonic/sDetail')
      // },
      {
        // 加班餐补审核
        path: '/admi/mealTonic/mealReview',
        name: 'mealTonicMealReview',
        component: () => import('@/views/admi/mealTonic/mealReview')
      },
      {
        // 我的工资条
        path: 'admi/salary/mysalary/',
        name: 'salary',
        component: () => import('@/views/admi/salary/index')
      },
      {
        // 我的考勤
        path: 'admi/checkWork/monthTotal',
        name: 'workset',
        component: () => import('@/views/admi/workset/index')
      },
      {
        // 考勤详情
        path: 'admi/workset/detail/',
        name: 'checkWorkdetail',
        component: () => import('@/views/admi/workset/detail')
      },
      {
        // 提醒设置
        path: 'admi/remind/reminderSettings/',
        name: 'reminderSettings',
        component: () => import('@/views/admi/remind/reminderSettings')
      },
      // 项目管理首页
      // {
      //   path: '/proj',
      //   name: 'proJIndex',
      //   component: () => import('@/views/proj/index')
      // },
      // 项目管理供应商信息列表
      {
        path: 'project/supplierManagement/information',
        name: 'projectInfo',
        component: () => import('@/views/project/supplierManagement/information')
      },
      // 项目管理供应商信息详细
      {
        path: 'project/supplierManagement/detail',
        name: 'projectDetail',
        component: () => import('@/views/project/supplierManagement/detail')
      },
      // 项目管理供应商信息新增与修改
      {
        path: 'project/supplierManagement/add',
        name: 'projectAdd',
        component: () => import('@/views/project/supplierManagement/add')
      },
      // 项目管理采购合同新增与修改
      {
        path: 'project/purchase/add',
        name: 'purchaseAdd',
        component: () => import('@/views/project/purchase/add')
      },
      // 项目管理采购合同详情
      {
        path: 'project/purchase/detail',
        name: 'purchaseDetail',
        component: () => import('@/views/project/purchase/detail')
      },
      // 项目管理采购合同草稿
      {
        path: 'project/purchase/addList',
        name: 'purchaseAddList',
        component: () => import('@/views/project/purchase/addList')
      },
      // 项目管理采购合同审批
      {
        path: 'project/purchase/approval',
        name: 'purchaseApproval',
        component: () => import('@/views/project/purchase/approval')
      },
      // 项目管理采购合同查询
      {
        path: 'project/purchase/query',
        name: 'purchaseQuery',
        component: () => import('@/views/project/purchase/query')
      },
      // 基本管理系统首页
      {
        path: '/system/index',
        name: 'systemIndex',
        component: () => import('@/views/system/index')
      },
      {
        // 行政管理系统首页
        path: '/admi',
        name: 'admiIndex',
        component: () => import('@/views/admi/index')
      },
      {
        // 部门列表
        path: '/system/dept/index',
        name: 'dept',
        component: () => import('@/views/system/dept')
      },
      {
        // 部门列表
        path: '/admi/user/index',
        name: 'userIndex',
        component: () => import('@/views/system/user')
      },
      {
        // 岗位管理
        path: '/system/post/index',
        name: 'postIndex',
        component: () => import('@/views/system/post')
      },
      {
        path: '/kehu',
        name: 'kehu',
        component: () => import('@/views/kehu')
      },
      {
        path: '/customer/:id',
        name: 'customer',
        component: () => import('@/views/kehu/customer-highseas')
      },
      {
        path: '/tongji',
        name: 'tongji',
        component: () => import('@/views/tongji')
      },
      {
        // 业绩消耗统计
        path: '/tongji/perfcons',
        name: 'perfconsStatistics',
        component: () => import('@/views/tongji/perfcons'),
        meta: { keepAlive: true }
      },
      {
        // 垫款统计
        path: '/tongji/advance',
        name: 'advanceStatistics',
        component: () => import('@/views/tongji/advance'),
        meta: { keepAlive: true }
      },
      {
        // scrm统计
        path: '/tongji/scrm',
        name: 'scrmStatistics',
        component: () => import('@/views/tongji/scrm'),
        meta: { keepAlive: true }
      },
      {
        // scrm统计 列表
        path: '/tongji/scrmList',
        name: 'scrmStatisticsList',
        component: () => import('@/views/tongji/scrmList')
      },
      {
        // bo统计 列表
        path: '/tongji/boList',
        name: 'boStatisticsList',
        component: () => import('@/views/tongji/boList')
      },
      {
        // contract统计
        path: '/tongji/contract',
        name: 'contractStatistics',
        component: () => import('@/views/tongji/contract'),
        meta: { keepAlive: true }
      },
      {
        // contract统计 列表
        path: '/tongji/contractList',
        name: 'contStatisticsList',
        component: () => import('@/views/tongji/contractList')
      },
      {
        // 统计明细
        path: '/tongji/details',
        name: 'statisticsDetail',
        component: () => import('@/views/tongji/details')
      },
      {
        // 事业部业绩统计
        path: '/fina/reportStatistics/performance',
        name: 'statisticsPerformance',
        component: () => import('@/views/tongji/performance')
      },
      {
        // 公司账户余额统计
        path: '/fina/reportStatistics/accountBalance',
        name: 'statisticsPerformance',
        component: () => import('@/views/tongji/accountBalance')
      },
      {
        path: '/daiban',
        name: 'daiban',
        component: () => import('@/views/daiban')
      },
      {
        path: '/daiban/custApproval',
        name: 'custApproval',
        component: () => import('@/views/daiban/custApproval')
      },
      {
        path: '/shezhi',
        name: 'shezhi',
        component: () => import('@/views/shezhi')
      },
      {
        path: '/shezhi/details',
        name: 'shezhiDetails',
        component: () => import('@/views/shezhi/details')
      },
      {
        path: '/shezhi/notice',
        name: 'notice',
        component: () => import('@/views/shezhi/notice')
      },
      {
        path: '/shezhi/noticeDetail',
        name: 'noticeDetail',
        component: () => import('@/views/shezhi/noticeDetail')
      }
    ]
  },
  // 客户详情
  {
    path: '/detail',
    name: 'detail',
    component: () => import('@/views/detail')
  },
  // 新建客户
  {
    path: '/client',
    name: 'add-client',
    component: () => import('@/views/add-client')
  }
]
const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default router
